export const CURRENCY_SYMBOLS = {
  USD: "$",
  EUR: "€",
  NOK: "kr",
};

// Currency codes in the order shown by the toggle
export const CURRENCY_CODES = ["USD", "EUR", "NOK"];

function symbol(currency) {
  return CURRENCY_SYMBOLS[currency] || "$";
}

// NOK convention: symbol after the number; USD/EUR: symbol before.
function place(value, currency) {
  const s = symbol(currency);
  if (currency === "NOK") return `${value}\u00a0${s}`;
  return `${s}${value}`;
}

export function money(value, currency = "USD") {
  if (value === null || value === undefined || isNaN(value)) return "—";
  const abs = Math.abs(value);
  let formatted;
  if (abs >= 1_000_000) formatted = (value / 1_000_000).toFixed(2) + "M";
  else if (abs >= 10_000) formatted = (value / 1_000).toFixed(1) + "K";
  else formatted = value.toLocaleString(undefined, { maximumFractionDigits: 0 });
  return place(formatted, currency);
}

export function moneyFull(value, currency = "USD") {
  if (value === null || value === undefined || isNaN(value)) return "—";
  const formatted = Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 });
  return place(formatted, currency);
}

export function pct(value, digits = 1) {
  if (value === null || value === undefined || isNaN(value)) return "—";
  return `${Number(value).toFixed(digits)}%`;
}

export function months(value) {
  if (value === null || value === undefined || value === Infinity) return "Beyond timeframe";
  return `${Number(value).toFixed(1)} mo`;
}

export function num(value, digits = 0) {
  if (value === null || value === undefined || isNaN(value)) return "—";
  return Number(value).toLocaleString(undefined, { maximumFractionDigits: digits });
}
